import React from 'react';
import { Box, Card, Typography } from '@material-ui/core';
import { Alert, Color } from '@material-ui/lab';

const isColor = (value: unknown): value is Color => {
  return typeof value === 'string' && ['success', 'info', 'warning', 'error'].includes(value);
};

const InformationPage = ({ location: { search } }) => {
  const searchParams = new URLSearchParams(search);
  const title = searchParams.get('title');
  const message = searchParams.get('message');
  const type = searchParams.get('type');

  return (
    <Box m={4} clone>
      <Card>
        <Box m={2}>
          <Typography gutterBottom variant='h5' component='h2'>
            {title}
          </Typography>
          <Alert severity={isColor(type) ? type : 'info'}>{message}</Alert>
        </Box>
      </Card>
    </Box>
  );
};

export default InformationPage;
